import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["link", "textarea"]

  async suggest(event) {
    event.preventDefault()
    
    const link = event.currentTarget
    const endpoint = link.href
    
    this.setLoading(true)

    try {
      const response = await fetch(endpoint, {
        headers: {
          "Content-Type": "application/json"
        }
      })

      const data = await response.json()

      if (response.ok) {
        this.textareaTarget.value = data.suggestion
        this.textareaTarget.focus()
      } else {
        alert(data.error || "An error occurred while generating suggestion")
      }
    } catch (error) {
      console.error("Error:", error)
      alert("An error occurred while generating suggestion")
    } finally {
      this.setLoading(false)
    }
  }

  setLoading(isLoading) {
    const link = this.linkTarget
    const spinner = link.querySelector('[data-spinner]')
    const icon = link.querySelector('[data-icon]')
    
    link.disabled = isLoading
    
    if (spinner && icon) {
      if (isLoading) {
        spinner.classList.remove("hidden")
        icon.classList.add("hidden")
      } else {
        spinner.classList.add("hidden")
        icon.classList.remove("hidden")
      }
    }
  }
} 